import {Controller, useFormContext} from "react-hook-form";
import {ContactTypeMap, NoContactInput} from "../../domain";
import {DropdownMultiSelect} from "common";
import React from "react";
import {SPLIT_DELIMITER, splitAndRemoveEmpty} from "../../../../placement/const";

type TypeOfContactInputProps = {
    sending: boolean;
};

export function TypeOfContactInput({sending}: TypeOfContactInputProps) {
    const {
        setValue,
        clearErrors,
        control,
        watch,
        formState: {
            errors
        },
    } = useFormContext<NoContactInput>();

    return (
        <div className="w-full text-black-200 pb-2 text-base items-center">
            <div className="flex items-center">
                <div className="w-2/6 text-right">
                    Type of Contact
                </div>
                <div className="w-1/6 ml-4 items-center">
                    <Controller
                        name="typeOfContact"
                        control={control}
                        rules={{
                            required: true
                        }}
                        render={() =>
                            <DropdownMultiSelect
                                field={'typeOfContact'}
                                options={Array.from(ContactTypeMap.keys())}
                                labelMapperFunc={(val) => ContactTypeMap.get(val)!!}
                                value={watch('typeOfContact')}
                                disabled={sending}
                                setValue={(selected) => {
                                    setValue("typeOfContact", splitAndRemoveEmpty(selected).join(SPLIT_DELIMITER))
                                    clearErrors("typeOfContact");
                                }}
                            />
                        }/>
                </div>
            </div>

            {
                errors.typeOfContact &&
                <div className="pt-2 flex w-full">
                    <div className="w-2/6">
                    </div>
                    <div className="w-4/6 ml-6 text-red-700">
                        Please select “Type of Contact” before submitting
                    </div>
                </div>
            }
        </div>
    );
}
